import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <footer className="footer clearfix">
        <div className="container">
          <div className="first-footer">
            <div className="row">
              <div className="col-md-12">
                <div className="links dark footer-contact-links" style={{ borderRadius: "8px", width: "full" }}>
                  <div className="footer-contact-links-wrapper">
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-solid fa-phone"></i>
                        </div>
                      </div>
                      <div className="footer-contact-link-content">
                        <h6>{t("call")}</h6>
                        <p>(+998) 87 619 00 80</p>
                      </div>
                    </div>

                    <div className="footer-contact-links-divider" />
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-solid fa-message"></i>
                        </div>
                      </div>
                      <div className="footer-contact-link-content">
                        <h6>{t("write")}</h6>
                        <p>rustamhaydarovich7@gmail.com</p>
                      </div>
                    </div>

                    <div className="footer-contact-links-divider" />
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-brands fa-telegram"></i>
                        </div>
                      </div>
                      <div className="footer-contact-link-content">
                        <h6>Telegram</h6>
                        <p>@TraveelSupport</p>
                      </div>
                    </div>

                    <div className="footer-contact-links-divider" />
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-solid fa-location-dot"></i>
                        </div>
                      </div>
                      <div className="footer-contact-link-content">
                        <h6>{t("address")}</h6>
                        <p>Tashkent, Uzbekistan</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="second-footer">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e9e9e9", borderRadius: "8px", background: "#fff" }}>
                  <h6 style={{ marginBottom: "10px" }}>{t("about_block_title")}</h6>
                  <p style={{ marginBottom: "8px", fontSize: "14px" }}>{t("about_block_text_1")}</p>
                  <p style={{ marginBottom: "0", fontSize: "14px" }}>{t("about_block_text_2")}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e9e9e9", borderRadius: "8px", background: "#fff" }}>
                  <h6 style={{ marginBottom: "10px" }}>{t("docs")}</h6>
                  <ul style={{ marginBottom: 0, paddingLeft: "18px", color: "#023f57" }}>
                    <li style={{ marginBottom: "6px" }}><a style={{ color: "#023f57", textDecoration: "none" }} href="/public-offer.docx" target="_blank" rel="noreferrer">{t("offer")}</a></li>
                    <li style={{ marginBottom: "6px" }}><a style={{ color: "#023f57", textDecoration: "none" }} href="/privacy-policy.docx" target="_blank" rel="noreferrer">{t("offer1")}</a></li>
                    <li style={{ marginBottom: "6px" }}><a style={{ color: "#023f57", textDecoration: "none" }} href="/payment-policy.docx" target="_blank" rel="noreferrer">{t("payment_refund_policy")}</a></li>
                    <li style={{ marginBottom: "6px" }}><a style={{ color: "#023f57", textDecoration: "none" }} href="/terms.docx" target="_blank" rel="noreferrer">{t("terms_of_use")}</a></li>
                    <li><a style={{ color: "#023f57", textDecoration: "none" }} href="/#contacts">{t("contact")}</a></li>
                  </ul>
                  <a
                    href="#contacts"
                    className="money glow-on-hover"
                    style={{ color: "black", backgroundColor: "white", display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: "12px", textDecoration: "none", width: "auto", minWidth: "180px", padding: "10px 16px", lineHeight: 1.2, whiteSpace: "nowrap" }}
                  >
                    {t("contact_request")}
                  </a>
                </div>
              </div>
              <div className="col-md-12">
                <div className="p-3" style={{ border: "1px solid #e9e9e9", borderRadius: "8px", background: "#fff" }}>
                  <h6 style={{ marginBottom: "10px" }}>{t("company_details_title")}</h6>
                  <div style={{ fontSize: "14px", lineHeight: "1.5" }}>
                    <p style={{ marginBottom: "4px" }}><strong>ПИНФЛ:</strong> 32003860560027</p>
                    <p style={{ marginBottom: "4px" }}><strong>Р/с:</strong> 2021 8000 2071 9449 0001</p>
                    <p style={{ marginBottom: "4px" }}><strong>МФО:</strong> 01158</p>
                    <p style={{ marginBottom: "4px" }}><strong>ИКПУ:</strong> 10602999999000000</p>
                    <p style={{ marginBottom: "4px" }}><strong>E-mail:</strong> rustamhaydarovich7@gmail.com</p>
                    <p style={{ marginBottom: "4px" }}><strong>{t("address")}:</strong> Tashkent, Uzbekistan</p>
                    <p style={{ marginBottom: "4px" }}><strong>Телефон:</strong> (+998) 87 619 00 80</p>
                    <p style={{ marginBottom: "0" }}><strong>Telegram:</strong> <a href="https://t.me/TraveelSupport" target="_blank" rel="noreferrer" style={{ color: "#023f57" }}>@TraveelSupport</a></p>
                    <p style={{ marginBottom: "0", marginTop: "4px" }}><strong>Сайт:</strong> Uzturagency.uz</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mx-auto d-flex max-w-7xl items-center justify-content-between px-4 py-6" id="contacts">
            <div className="flex items-center gap-6">
              <p className="text-sm text-muted-foreground">©2026 Innosoft systems All rights reserved</p>
            </div>
            <div className="flex items-center gap-2">
              <img style={{ width: "60px", height: "20px", marginRight: "8px" }} src="/img/pngaaa.com-176837.png" alt="Visa" />
              <span style={{ fontWeight: 600, fontSize: "14px" }}>Mastercard</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
